module.exports = function(bh) {
    bh.match('nav-panel__title', function(ctx, json) {
        ctx.cls('h4');
    });
};

